import axios from 'axios';
import { clearCreds, getCreds, saveCreds } from 'common/axios/jwt/creds';
import { ICreds, IJwtInterceptorsConfig, REFRESH_TIMEOUT_MS } from 'common/axios/jwt/types';

let tokenUpdater: Promise<ICreds> | null = null;

export const refreshToken = (config: IJwtInterceptorsConfig): Promise<ICreds> => {
  if (tokenUpdater) {
    return tokenUpdater;
  }

  const creds = getCreds();
  if (!creds.refresh?.token) {
    return Promise.reject(new Error('No refresh token'));
  }

  // Separate instance without interceptors so refresh does not loop through JWT logic.
  const refreshInstance = axios.create({
    baseURL: config.axios.defaults.baseURL,
    timeout: REFRESH_TIMEOUT_MS,
  });

  tokenUpdater = refreshInstance
    .put(config.refreshTokenEndpoint, { refreshToken: creds.refresh.token })
    .then((res) => {
      const payload = res.data?.access ? res.data : res.data?.data;
      return saveCreds(payload as ICreds);
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        clearCreds();
      }
      throw err;
    })
    .finally(() => {
      tokenUpdater = null;
    });

  return tokenUpdater;
};
